export enum QaCheckFrequencyTypes {
  None = 'None',
  Minutes = 'Minutes',
  Container = 'Container',
  ProcessingUnit = 'ProcessingUnit',
  Order = 'Order'
}
